import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const CARRERAS_CONST = 'carreras';
export const carreras_api = `${baseUrl}/${CARRERAS_CONST}`;

export const allCarrerasService = async (params) => {
  const res = await axios.get(carreras_api, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveCarrerasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${carreras_api}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(carreras_api, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneCarrerasService = async (id) => {
  const res = await axios.get(`${carreras_api}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteCarrerasService = async (id) => {
  const res = await axios.delete(`${carreras_api}/${id}`, {
    headers: token({}),
  });
  return res;
};
